(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kalu-announcement"]) return;
  try {
    
  if (!customElements.get('kalu-announcement')) {
    class KaluAnnouncement extends HTMLElement {
      connectedCallback() {
        this.applyHeight();
        if (typeof ResizeObserver !== 'undefined') {
          this.ro = new ResizeObserver(() => this.applyHeight());
          this.ro.observe(this);
        }
        window.addEventListener('resize', this.applyHeight.bind(this), { passive: true });
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        document.documentElement.style.removeProperty('--announcement-height');
      }

      applyHeight() {
        // getBoundingClientRect renvoie un float (vs offsetHeight entier) →
        // évite le gap sub-pixel sur écrans retina (iOS notamment).
        // Math.floor : la variable est ≤ hauteur réelle → l'annonce déborde
        // toujours un peu sous la zone occupée par le contenu et le header
        // (qui ont tous deux z-index < 101), donc aucun gap visible quel
        // que soit l'arrondi du device.
        const rect = this.getBoundingClientRect();
        const h = Math.floor(rect.height);
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }
    }
    customElements.define('kalu-announcement', KaluAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kalu-header"]) return;
  try {
    
  (function () {
    const init = () => {
      const header = document.querySelector('.kalu-header');
      if (!header) return;

      // --- Mobile burger menu (overlay lives outside the header, found via aria-controls) ---
      const burger = header.querySelector('.kalu-header__burger');
      const menu = burger ? document.getElementById(burger.getAttribute('aria-controls')) : null;
      if (burger && menu) {
        const closeMenu = () => {
          header.classList.remove('is-menu-open');
          menu.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        };
        const openMenu = () => {
          header.classList.add('is-menu-open');
          menu.classList.add('is-open');
          burger.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
        };
        burger.addEventListener('click', () => {
          if (header.classList.contains('is-menu-open')) closeMenu();
          else openMenu();
        });
        menu.addEventListener('click', (event) => {
          // Close when a link is clicked or the empty backdrop is tapped
          if (event.target.closest('.kalu-header__menu-link') || event.target === menu) {
            closeMenu();
          }
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && header.classList.contains('is-menu-open')) {
            closeMenu();
            burger.focus();
          }
        });
      }

      const overlayTarget =
        document.querySelector('[data-hero-overlay-header]') ||
        document.querySelector('#kalu-hero') ||
        document.querySelector('.section-kalu-hero');
      const main = document.querySelector('#MainContent');

      if (!overlayTarget) {
        header.classList.add('is-scrolled');
        if (main) {
          const apply = () => {
            main.style.paddingTop = header.offsetHeight + 'px';
          };
          apply();
          window.addEventListener('resize', apply, { passive: true });
        }
        return;
      }

      const threshold = 80;
      let ticking = false;
      const update = () => {
        if (window.scrollY > threshold) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
        ticking = false;
      };
      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
          }
        },
        { passive: true }
      );
      update();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
